import { APIRequests } from '../../../config/api';
import { DataType } from '../../../types';
import { ListViewConfig, PageViewConfig } from './index';

export const quizList: ListViewConfig = {
  title: "Quizzes",
  apiRequest: APIRequests.QuizList,
  emptyMessage: "No quizzes found",
  columns: [
    {
      name: 'created_at',
      label: 'Created',
      type: DataType.Date,
      sorted: 'desc',
      editable: false
    },
    {
      name: 'title',
      label: 'Title'
    },
    {
      name: 'active',
      label: 'Active'
    },
    {
      name: 'version',
      label: 'Version'
    },
    {
      name: 'code',
      label: 'Code'
    },

  ]
}

export const quizEdit: PageViewConfig = {
  title: "title",
  sections: [
    {
      title: '',
      layout: 6,
      fields: [
        {
          name: 'title',
          label: 'Title',
          editable: true
        },
        {
          name: 'active',
          label: 'Active',
          editable: true
        },
        {
          name: 'end_message',
          label: 'End Message',
          editable: true
        },
        {
          name: 'end_link',
          label: 'End Link',
          editable: true
        },
        {
          name: 'end_button_text',
          label: 'End Button Text',
          editable: true
        },
      ]
    }
  ],
  related: [
    {
      title: "Questions",
      apiRequest: APIRequests.QuestionList,
      relatedFilter: "quiz_id",
      emptyMessage: "No questions found",
      columns: [
        {
          name: 'code',
          label: 'Code'
        },
        {
          name: 'title',
          label: 'Title'
        },
        {
          name: 'kind',
          label: 'Question Type'
        },
        {
          name: 'is_active',
          label: 'Active'
        },
      ]
    },
  ]
}